import {
  CaseListActionTypes,
  CaseListDetailsState,
  CASE_LIST_LOADING,
  CASE_LIST_SUCCESS,
  CASE_LIST_FAIL,
  CASE_LIST_UPDATE_API_MSG,
  CASE_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { CaseListResponse } from "./Model";

const initialStateGetPosts: CaseListDetailsState = {
  loading: false,
  caseListResponse: {} as CaseListResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const patientCaseListReducer = (
  state = initialStateGetPosts,
  action: CaseListActionTypes
): CaseListDetailsState => {
  switch (action.type) {
    case CASE_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case CASE_LIST_SUCCESS:
      return {
        ...state,
        caseListResponse: action.payload,
        successMsg: action.successMsg,
      };
    case CASE_LIST_FAIL:
      return {
        ...state,
        caseListResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case CASE_LIST_UPDATE_API_MSG:
      return {
        ...state,
        caseListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case CASE_LIST_UPDATE_API_RES:
      return {
        ...state,
        caseListResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
